// Global packages and components
import { clsx } from 'clsx'
import { ContentEditor, BannerImage } from '~/components'
import { Link } from '@remix-run/react'

// Types
import type { CategoryBannerProps } from '~/types'

// Inner content
const BannerInner = ({ image, content, layout, size }: CategoryBannerProps) => (
  <>
    <div
      className={clsx(
        'relative z-[2] w-full px-6 text-white last:*:mb-0 lg:px-10',
        {
          'lg:max-w-[60%]': layout !== 'centre' && size !== 'small',
          'text-center': layout == 'centre',
          'py-10': size == 'large',
          'py-8': size == 'small',
        }
      )}
    >
      {content && <ContentEditor content={content} />}
    </div>
    <BannerImage image={image} />
  </>
)

// Main export
const CategoryBanner = ({
  image,
  content,
  layout,
  size,
  link,
}: CategoryBannerProps) => {
  const wrapperClass = clsx('relative flex items-center rounded-2xl', {
    'justify-center': layout == 'centre',
    'aspect-banner-thin': size == 'large',
    'aspect-banner-letterbox': size == 'small',
  })

  return link ? (
    <Link
      to={link}
      className={wrapperClass}
    >
      <BannerInner
        image={image}
        content={content}
        layout={layout}
        size={size}
      />
    </Link>
  ) : (
    <div className={wrapperClass}>
      <BannerInner
        image={image}
        content={content}
        layout={layout}
        size={size}
      />
    </div>
  )
}
export default CategoryBanner
